/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import { v4 as uuid } from 'uuid';
import AWS from 'aws-sdk';
import {
  LogLevel,
  ConsoleLogger,
  DefaultMessagingSession,
  MessagingSessionConfiguration,
  PrefetchOn
} from 'amazon-chime-sdk-js';

import { getMessagingSessionEndpoint, createMemberArn } from '../api/ChimeAPI';
interface memberObject {
  username: string,
  userId: string
}
class MessagingService {

  private static instance: MessagingService;
  private _member: memberObject; // Store member information
  public static getInstance(): MessagingService {
    if (!MessagingService.instance) {
      MessagingService.instance = new MessagingService();
    }

    return MessagingService.instance;
  }

  public _session: DefaultMessagingSession;
  public sessionId: string;
  public _logger: ConsoleLogger;
  public _messageUpdateCallbacks: any[];
  public _endpoint: string;

  constructor() {
    this._session = {} as DefaultMessagingSession;
    this.sessionId = uuid();
    this._logger = new ConsoleLogger('SDK Chat Demo', LogLevel.INFO);
    this._messageUpdateCallbacks = [];
    this._endpoint = "";
    this._member = { userId: "", username: "" };
  }

  public async setMember(member: memberObject) {
    this._member = member;
  }

  messageObserver = {
    messagingSessionDidStart: () => {
      console.log('Messaging Connection started! ...');
    },
    messagingSessionDidStartConnecting: () => {
      console.log('Messaging Connection connecting');
    },
    messagingSessionDidStop: () => {
      console.log('Messaging Connection received DidStop event');
      this.reconnect();
    },
    messagingSessionDidReceiveMessage: (message: any) => {
      this.publishMessageUpdate(message);
    }
  };

  setMessagingEndpoint(member: any) {
    getMessagingSessionEndpoint()
      .then(async response => {
        this._endpoint = response?.Endpoint?.Url;
        const sessionConfig = new MessagingSessionConfiguration(
          createMemberArn(member.userId),
          this.sessionId,
          this._endpoint,
          new AWS.ChimeSDKMessaging()
        );
        sessionConfig.prefetchOn = PrefetchOn.Connect;
        this._session = new DefaultMessagingSession(
          sessionConfig,
          this._logger
        );

        this._session.addObserver(this.messageObserver);
        this._session.start();
      })
      .catch(err => {
        console.error("connect messaging endpoint error===: ", err);
        this.reconnect();
      });
  }

  async reconnect() {
    console.log('Attempting to reconnect...');
    setTimeout(() => this.setMessagingEndpoint(this._member), 5000);
  }

  connect(member: memberObject) {
    this.setMember(member);
    this.setMessagingEndpoint(member);
  }

  close() {
    try {
      this._session.stop();
    } catch (err) {
      console.error('Failed to stop Messaging Session.');
    }
  }

  subscribeToMessageUpdate(callback: any) {
    console.log('Message listener subscribed!');
    this._messageUpdateCallbacks.push(callback);
  }

  unsubscribeFromMessageUpdate(callback: any) {
    const index = this._messageUpdateCallbacks.indexOf(callback);
    if (index !== -1) {
      this._messageUpdateCallbacks.splice(index, 1);
    }
  }

  publishMessageUpdate(message: any) {
    for (let i = 0; i < this._messageUpdateCallbacks.length; i += 1) {
      const callback = this._messageUpdateCallbacks[i];
      callback(message);
    }
  }
}

export default MessagingService;
